module.exports = __webpack_public_path__ + "static/media/AS.b9f81c2d.svg";